import { APIError } from 'models/baseResponse'

/* eslint-disable  @typescript-eslint/no-explicit-any */
export function reactQueryRetryHandler(failureCount: any, error: any) {
  return !(
    failureCount > 3 ||
    (error instanceof APIError && error.status && [400, 404].indexOf(error.status) !== -1)
  )
}
